import { useParams as e } from "react-router-dom";
import { getUseQueryHookState as o } from "../../../common/utils/getUseQueryHookState.js";
const t = (e2) => ({ id: e2.id, value: e2.value }), r = (e2) => e2 ? e2.map(t) : [], i = ({ meteringNodeId: t2 = null, hooks: i2 }) => {
  const { commercialMeteringPointId: d } = e(), { data: n, ...a } = i2.useGetSeasonTypesQuery({}), { data: s, ...u } = i2.useGetMeteringNodeKindQuery({}), { data: m, ...y } = i2.useGetMeteringNodeTypeQuery({}), { data: g, ...p } = i2.useGetMeteringNodeLocationTypeQuery({}), N = d ? i2.useGetMeteringNodeByIdCommercialQuery : i2.useGetMeteringNodeByIdQuery, { data: c, ...l } = N(t2, { skip: !t2 });
  return { isLoading: o("isLoading", [a, u, y, p, l]), isError: o("isError", [a, u, y, p, l]), meteringNode: c, seasonTypes: r(n), meteringNodeKind: r(s), meteringNodeType: r(m), meteringNodeLocationType: r(g) };
};
export {
  r as getMappedOptions,
  i as useFetchFormData
};
//# sourceMappingURL=useFetchFormData.js.map
